<div class="me-auto pc-mob-drp">
  <ul class="list-unstyled">
    <li class="pc-h-item header-mobile-collapse">
      <a
        href="javascript:"
        class="pc-head-link head-link-secondary ms-0 mobile-menu"
        id="mobile-collapse mobile-collapse1"
        (click)="this.NavCollapsedMob.emit()"
      >
        <i class="ti ti-menu-2"></i>
      </a>
    </li>
    <li class="pc-h-item">
      <app-page-breadcrumb></app-page-breadcrumb>
    </li>
  </ul>
</div>
